import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { pageAnimation } from "../animate";
import ScrollTop from "../components/ScrollTop";
import TypeIt from "typeit";
import python from "../img/devpython.png";
import Python from "../img/python.png";
import Duplicatebro from "../img/funpana.png";
import CourseDetail6 from "../components/CourseDetail6";
import CourseDetail61 from "../components/CourseDetail61";

const LinearAlgebra = () => {
  useEffect(() => {
    new TypeIt("#element", {
      strings: ["2026 Python全攻略"],
      speed: 100,
      afterComplete: (instance) => {
        const el = document.querySelector("#element");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
    }).go();

    new TypeIt("#element2", {
      strings:
        "超過40小時的內容，學習Python語法、程式邏輯、識別Python資料類別與使用時機，用正規表示式處理資料、處理文件系統、運用Python網路爬蟲、連結SQL資料庫、處理Excel和csv，寄送email，一步步實作成為Python達人！",
      speed: 15,
      afterComplete: (instance) => {
        const el = document.querySelector("#element2");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
      startDelay: 1500,
      loop: false,
    }).go();
  }, []);

  return (
    <div>
      <motion.div
        variants={pageAnimation}
        initial="hidden"
        animate="show"
        className="webdev"
        exit="exit"
      >
        <div className="img">
          <img src={Python} alt="" />
        </div>
        <div className="desc">
          <h1>
            <span id="element"></span>
          </h1>
          <div className="content">
            <h3 id="element2"></h3>
          </div>
          <div>
            <p>
              課程價格: <span className="hide">新台幣$290</span>{" "}
            </p>
            <p>
              優惠代碼(點擊連結即可自動套用優惠碼):
              <br />
              <a
                target="_blank"
                href={`https://www.udemy.com/course/python-master/?couponCode=${process.env.REACT_APP_PYTHON_COUPON}`}
              >
                <span>{process.env.REACT_APP_PYTHON_COUPON}</span>
              </a>
              (只到
              <span style={{ color: "red" }}>{process.env.REACT_APP_DATE}</span>
              之前有效)
            </p>
            <p>
              課程連結:
              <br />
              <a
                target="_blank"
                href={`https://www.udemy.com/course/python-master/?couponCode=${process.env.REACT_APP_PYTHON_COUPON}`}
              >
                <span className="hide">
                  https://www.udemy.com/course/python-master/
                </span>
              </a>
            </p>
            {/* <p style={{ fontSize: "5px", opacity: "0.9" }} target="_blank">
              Hiskio 平台課程連結
              (無法使用優惠碼)：https://hiskio.com/courses/1280/about
            </p> */}
          </div>
        </div>
        <CourseDetail61 img={Duplicatebro} />
        <CourseDetail6 img={python} />
        <ScrollTop />
      </motion.div>
    </div>
  );
};

export default LinearAlgebra;
